import { render, staticRenderFns } from "./bip-card.vue?vue&type=template&id=4851bc74&scoped=true&"
import script from "./bip-card.vue?vue&type=script&lang=ts&"
export * from "./bip-card.vue?vue&type=script&lang=ts&"
import style0 from "./bip-card.vue?vue&type=style&index=0&id=4851bc74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4851bc74",
  null
  
)

export default component.exports